
import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EventPageHeaderProps {
  onAddEvent: () => void;
}

const EventPageHeader: React.FC<EventPageHeaderProps> = ({ onAddEvent }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start mb-8">
      <div>
        <h1 className="text-3xl font-bold mb-2">Events</h1>
        <p className="text-muted-foreground">
          Discover upcoming eco-friendly events and activities
        </p>
      </div>
      <div className="mt-4 md:mt-0">
        <Button 
          onClick={onAddEvent}
          className="bg-eco-500 hover:bg-eco-600 flex items-center gap-2"
        >
          <Plus size={16} />
          Add Event
        </Button>
      </div>
    </div>
  );
};

export default EventPageHeader;
